import { render } from "./servicesComponent.vue?vue&type=template&id=685487b0"
import script from "./servicesComponent.vue?vue&type=script&lang=js"
export * from "./servicesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__